import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 路由表
const routes = [
  {
    path: '/',
    component: () => import('@/views/index')
  },
  {
    path: '/new/index_one/:dynamicData+',
    name: 'new',
    // redirect: '/',
    component: () => import('@/views/new')
  },
  {
    path: '/index',
    name: 'index',
    redirect: '/'
  },
  {
    path: '/pickActivity/:dynamicData+',
    name: 'pickActivity',
    component: () => import('@/views/pickActivity')
  },
  {
    path: '/:id',
    name: 'h5OpenMini',
    component: () => import('@/views/h5OpenMini')
  },
  {
    path: '/vxPublic/index/:dynamicData+',
    name: 'vxPublic',
    // redirect: '/',
    component: () => import('@/views/vxPublic/index')
  },
  {
    path: '/vxPublic/collect/:dynamicData+',
    name: 'collect',
    // redirect: '/',
    component: () => import('@/views/vxPublic/collect')
  },
  {
    path: '/vxPublic/success/:dynamicData+',
    name: 'success',
    // redirect: '/',
    component: () => import('@/views/vxPublic/success')
  },
  {
    path: '/vxPublic/successTwo/:dynamicData+',
    name: 'successTwo',
    // redirect: '/',
    component: () => import('@/views/vxPublic/successTwo')
  },
  {
    path: '/vxPublic/index_two/:dynamicData+',
    name: 'index_two',
    // redirect: '/',
    component: () => import('@/views/vxPublic/index_two')
  },
  {
    path: '/vxPublic/index_three/:dynamicData+',
    name: 'index_three',
    // redirect: '/',
    component: () => import('@/views/vxPublic/index_three')
  },
  {
    path: '/vxPublic/index_four/:dynamicData+',
    name: 'index_four',
    // redirect: '/',
    component: () => import('@/views/vxPublic/index_four')
  },
  {
    path: '/vxPublic/orderPay/:dynamicData+',
    name: 'orderPay',
    // redirect: '/',
    component: () => import('@/views/vxPublic/orderPay')
  },
  {
    path: '/smallProgram/index/:dynamicData+',
    name: 'index',
    // redirect: '/',
    component: () => import('@/views/smallProgram/index')
  },
  {
    path: '/smallProgram/success/:dynamicData+',
    name: 'success',
    // redirect: '/',
    component: () => import('@/views/smallProgram/success')
  },
  {
    path: '/smallProgram/orderPay/:dynamicData+',
    name: 'orderPay',
    // redirect: '/',
    component: () => import('@/views/smallProgram/orderPay')
  },
  {
    path: '/smallProgram/userInfo_code/:dynamicData+',
    name: 'userInfo_code',
    // redirect: '/',
    component: () => import('@/views/smallProgram/userInfo_code')
  },
  {
    path: '/smallProgram/two/index/:dynamicData+',
    name: 'index',
    // redirect: '/',
    component: () => import('@/views/smallProgram/two/index')
  },{
    path: '/smallProgram/two/userInfo_code/:dynamicData+',
    name: 'userInfo_code',
    // redirect: '/',
    component: () => import('@/views/smallProgram/two/userInfo_code')
  },
  {
    path: '/smallProgram/two/success/:dynamicData+',
    name: 'success',
    // redirect: '/',
    component: () => import('@/views/smallProgram/two/success')
  },
  {
    path: '/new/index_two/:dynamicData+',
    name: 'index_two',
    // redirect: '/',
    component: () => import('@/views/new/index_two')
  },
  {
    path: '/new/index_three/:dynamicData+',
    name: 'index_three',
    // redirect: '/',
    component: () => import('@/views/new/index_three')
  },
  {
    path: '/smallProgram/three/index/:dynamicData+',
    name: 'index',
    // redirect: '/',
    component: () => import('@/views/smallProgram/three/index')
  },
  {
    path: '/smallProgram/three/middle/:dynamicData+',
    name: 'middle',
    // redirect: '/',
    component: () => import('@/views/smallProgram/three/middle')
  },
  {
    path: '/app/scanWXcode/:dynamicData+',
    name: 'scanWXcode',
    // redirect: '/',
    component: () => import('@/views/app/scanWXcode')
  },
  {
    path: '/app/success/:dynamicData+',
    name: 'success',
    // redirect: '/',
    component: () => import('@/views/app/success')
  },
  {
    path: '/app/download/index/:dynamicData+',
    name: 'index',
    // redirect: '/',
    component: () => import('@/views/app/download/index')
  },
  {
    path: '/ceshi/index/:dynamicData+',
    name: 'index',
    // redirect: '/',
    component: () => import('@/views/ceshi/index')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
  console.log('to', to)
  console.log('from', from)

  // 如果访问的是 success 页面且没有携带 dynamicData 参数，则重定向到带有随机字符串的路径
  if (!to.params.dynamicData) {
    // 生成随机字符串
    const randomStr = Math.random().toString(36).substring(2, 10)
    // 构建新的路径，保留查询参数
    const newPath = `${to.path}/${randomStr}`
    if (Object.keys(to.query).length > 0) {
      const queryString = new URLSearchParams(to.query).toString()
      next(`${newPath}?${queryString}`)
    } else {
      next(newPath)
    }
  } else {
    next()
  }
})

export default router
